import P1 from './p1.avif';
import P2 from './p2.png';
import P3 from './p3.avif';
import P4 from './p4.avif';
import P5 from './p5.avif';
import CollectionIndexPage from '../../Collection/CollectionIndexPage'

const getSections = (t) => {

    return [
        {
            id: 'p1',
            header: t('libraryTitle', 'L’Українка – українська бібліотека Оттави'),
            text: t('libraryDescription', `<b>L’Українка – українська бібліотека Оттави</b> – це соціальний проект спрямований на створення бібліотеки з колекцією україномовних книжок сучасних авторів, класиків української літератури та перекладних книжок світової літератури для дітей та дорослих, у місті Оттава (Онтаріо, Канада).
    
    <br/><br/><b>Хто створив:</b> Ініціатором і виконавцем проєкту є громадська організація «Українська школа імені Лесі Українки в Оттаві» за підтримки Української Кредитової Спілки. Бібліотечний фонд було зібрано завдяки щедрій підтримці Шевченківської фундації через фонд Алекса та Віри Канарейських, Посольства України в Канаді, а також приватним пожертвам і підтримці громади.
    
    <br/><br/><b>Де зберігатимуться книги:</b> Усі зібрані та закуплені книги зберігатимуться у приміщенні Української Кредитової Спілки(Оттавського відділення).`),
            image: { src: P1, width: '200px', height: '200px' },
            imageOnLeft: true,
        },
        {
            id: 'p2',
            header: t('howToRegisterHeader', 'Як зареєструватися до бібліотеки'),
            text: t('howToRegisterText', `Стати читачем L’Українка - українська бібліотека Оттави Ви можете оплативши щорічний внесок у розмірі 20 CAD за посиланням нижче. Після оплати Вам на електронну скриньку, використану при проплаті, буде надіслано листа від library.ukrainianschoolottawa.ca з посиланням на реєстрацію. Також Ви отримаєте листа від library@ukrainianschoolottawa.ca  з інструкцією щодо використання бібліотеки. Інформацію з листа Ви також можете переглянути тут.`),
            image: null,
        },
        {
            id: 'p3',
            header: '',
            text: '',
            path: '/sign-up',
            button: t('signUp', 'Реєстрація'),
        },
        {
            id: 'p4',
            header: t('howToOrderHeader', 'Як замовити та де забрати/повернути книги'),
            text: t('howToOrderText', `Переглянути та замовити книги з бібліотеки можна онлайн, користуючиcь електронним каталогом, який Ви зайдете тут.
    
    Після замовлення книг на сайті бібліотеки, їх можна буде забрати у найближчу суботу після дати замовлення, в приміщенні Української школи ім.Лесі Українки в Оттаві, за адресою 1303 Fellows Rd, від 11:00 до 11:45 ранку. Повернути книги можна буде у найближчу суботу перед закінченням Вашого замовлення за тією ж адресою, у той же час.`),
            image: { src: P2, width: '249px', height: '202px' },
            imageOnLeft: false,
        },
        {
            id: 'p5',
            header: t('forWhomHeader', 'Для кого створена бібліотека'),
            text: t('forWhomText', `&nbsp; &nbsp; Скористатися послугами бібліотеки можуть всі бажаючі діти та дорослі, не лише учні та батьки школи. Для того, щоб скористатися послугами бібліотеки потрібно пройти простий процес реєстрації описаний вище.`),
            image: { src: P3, width: '284px', height: '197px' },
            imageOnLeft: true,
        },
        {
            id: 'p6',
            header: t('booksHeader', 'Книги у бібліотеці'),
            text: t('booksText', `&nbsp; &nbsp; Основну частину бібліотеки складають подаровані та пожертвувані українською громадою книги. Кожен бажаючий може подарувати бібліотеці україномовні книги, як вживані так і нові, від 2000 року видання. Література, також, закуповуватиметься на зібрані від спонсорів та проведення фандрайзингів кошти.
    
    <p>&nbsp; &nbsp; Книги у бібліотеці є україномовними виданнями від 2000 року. В колекції буде представлена як доросла так і дитяча література різних жанрів. У бібліотеці можна буде знайти як класиків української і світової літератури, так і сучасних авторів. У бібліотеці, також, є невелика колекція англомовних книг про Україну.
    
    <br/><br/><b>Якщо ви хочете підтримати проект фінансово, надсилайте e-transfer на електронну адресу: <a href="mailto:library@ukrainianschoolottawa.ca" target="_self" class="wixui-rich-text__text">library@ukrainianschoolottawa.ca&nbsp;</a></b>`),
            image: { src: P4, width: '335px', height: '188px' },
            imageOnLeft: false,
        },
        {
            id: 'p9',
            header: t('latestArrivalsHeader', 'Останні надходження'),
            component: CollectionIndexPage,
            text: t('latestArrivalsText', ``),
            image: { src: P5, width: '278px', height: '172px' },
            imageOnLeft: false,
        },
        {
            id: 'p8',
            header: '',
            text: t('contactsFooter', `<footer style="padding: 20px 0; font-size: 12px; text-align: center; font-family: sans-serif;">
      <h2 style="font-weight: bold; margin-bottom: 10px;">Наші контакти</h2>
      <p style="margin: 5px 0; display:flex; align-items:center; gap:8px; justify-content:center;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" style="width:16px;height:16px;">
          <path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"/>
        </svg>
        <a href="mailto:library@ukrainianschoolottawa.ca" aria-label="Електронна пошта: library@ukrainianschoolottawa.ca">library@ukrainianschoolottawa.ca</a>
      </p>
      <p style="margin: 5px 0; display:flex; align-items:center; gap:8px; justify-content:center;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" style="width:16px;height:16px;">
          <path fill="currentColor" d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-3h2.5V9.5c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.3c-1.3 0-1.7.8-1.7 1.6V12H18l-.5 3h-2.5v7A10 10 0 0 0 22 12"/>
        </svg>
        <a href="https://www.facebook.com/groups/392956789966478" rel="noopener noreferrer" aria-label="Facebook група" target="_blank">Facebook</a>
      </p>
      <p style="margin: 5px 0;">
        <strong>Наша адреса:</strong> 1303 Fellows Rd, Ottawa,ON K2C2V8
      </p>
    </footer>`),
        }
    ];
};

export default getSections;
